module.exports = __webpack_public_path__ + "static/media/family.ad7a9ae6.png";